import { ArrowUpRight, Check } from "lucide-react";

const SERVICE_IMGS = [
  "/nr10-card.png",
  "/nr33-card.png",
  "/nr35-card.png",
];

const Services = ({ t, onOpenConsult }) => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-[#f8f9fa] py-24 sm:py-32"
    >
      <div className="bid-container">
        <div className="max-w-3xl mb-16">
          <p className="bid-overline text-[#d4af37] mb-4">{t.services.overline}</p>
          <h2
            className="text-3xl sm:text-4xl lg:text-5xl font-display font-black text-[#0a192f] tracking-tight leading-tight"
            data-testid="services-title"
          >
            {t.services.title}
          </h2>
          <p className="mt-4 text-base sm:text-lg text-[#4a5568] leading-relaxed">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {t.services.items.map((s, i) => (
            <article
              key={i}
              data-testid={`service-card-${i}`}
              className="group bg-white border border-[#0a192f]/10 flex flex-col hover:border-[#d4af37] hover:shadow-2xl transition-all duration-300"
            >
              <div className="relative h-56 overflow-hidden">
                <img
                  src={SERVICE_IMGS[i]}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0a192f]/70 via-transparent to-transparent" />
                <div className="absolute top-4 left-4 bg-[#d4af37] text-[#0a192f] px-3 py-1 font-display font-black text-xs tracking-wider">
                  {s.tag}
                </div>
              </div>

              <div className="p-8 flex flex-col flex-1">
                <h3 className="font-display text-2xl font-bold text-[#0a192f] leading-snug">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-[#4a5568] leading-relaxed">{s.desc}</p>

                <ul className="mt-6 space-y-2.5">
                  {s.bullets.map((b, j) => (
                    <li key={j} className="flex gap-2 items-start text-sm text-[#0a192f]/80">
                      <Check className="w-4 h-4 text-[#d4af37] mt-0.5 flex-shrink-0" strokeWidth={3} />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>

                <button
                  onClick={onOpenConsult}
                  data-testid={`service-cta-${i}`}
                  className="mt-8 inline-flex items-center gap-2 text-[#0a192f] font-display font-bold uppercase tracking-wider text-xs hover:text-[#d4af37] transition-colors self-start"
                >
                  {t.common.learnMore}
                  <ArrowUpRight className="w-4 h-4" />
                </button>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
